import ConfirmDialog from '@/components/ConfirmDialog';
import Icon, {IconSize} from '@/components/Icon';
import {ExternalCopyWarnSvg, DialogCloseSvg, NoteTipSvg} from '@/icons';
import {DialogHead} from '@baidu/luffy';
import classNames from 'classnames';
import styles from './index.module.scss';
import {DialogBody, DialogFoot} from '@/components/Dialog';
import {InvalidType} from '@/Constant';

interface externalWarnDialogProps {
    invalidVisible: boolean;
    onClose: () => void;
    invalidType: InvalidType;
    dialogType: 'copy' | 'move';
}

export default function ExternalWarnDialog(props: externalWarnDialogProps) {
    const {invalidVisible, onClose, invalidType, dialogType} = props;

    function renderInvalidText(type: InvalidType) {
        if (type === InvalidType.noDocOrBook) {
            return <div className={styles.invalidText}>
                <div className={styles.invalidTextTitle}>你所选的内容存在部分页面类型在外部知识库不支持。</div>
                <div className={styles.invalidTextContent}>
                    <Icon svg={NoteTipSvg} size={IconSize.Auto} />
                    <div>外部知识库仅支持：1. 文档；2. 知识本</div>
                </div>
            </div>;
        } else if (type === InvalidType.isPublic) {
            return <div className={styles.invalidText}>
                你所选的部分页面已经设置企业内公开，请先关闭企业内公开再进行操作。
            </div>;
        }
    }

    return (
        <ConfirmDialog
            visible={invalidVisible}
            showCloseX={false}
            showHeader={false}
            className={classNames(styles.invalidDia)}
        >
            <DialogHead>
                <div className={styles.invalidContentHeader}>
                    <div className={styles.invalidContentHeaderLeft}>
                        <Icon svg={ExternalCopyWarnSvg} size={IconSize.Auto} />
                        <span>
                            {
                                dialogType === 'copy'
                                    ? '复制失败'
                                    : '移动失败'
                            }
                        </span>
                    </div>
                    <Icon
                        svg={DialogCloseSvg}
                        size={IconSize.Auto}
                        className={styles.rightCloseSvg}
                        onClick={onClose}
                    />
                </div>
            </DialogHead>
            <DialogBody>
                {renderInvalidText(invalidType)}
            </DialogBody>
            <DialogFoot>
                <div className={styles.invalidBtnBox}>
                    <div
                        className={classNames(styles.btnP, styles.btnCloseBox)}
                        onClick={onClose}
                    >取消</div>
                    <div
                        className={classNames(styles.btnP, styles.btnOKBox)}
                        onClick={onClose}
                    >确定</div>
                </div>
            </DialogFoot>
        </ConfirmDialog>
    );
}
